<nz-spin [nzSpinning]="loading">
  @if (clientNotificationConfig) {
    <div nz-col nzSpan="24">
      @if (client) {
        @if (client.clientEmail) {
          <p><strong>Klients (To): </strong>{{ client.clientEmail }}</p>
        }
        @if (!client.clientEmail) {
          <p><strong>Klients (To):</strong></p>
        }
        @if (!client.clientEmail) {
          <p>Klientam nav norādīta e-pasta adrese!</p>
        }
      }
      @if (contact) {
        <p><strong>Kontakts (To):</strong></p>
        @if (contact.contactEmail) {
          <label nz-checkbox [(ngModel)]="clientNotificationConfig.sendToContact">{{ contact.contactEmail }}</label>
        }
        @if (!contact.contactEmail) {
          <p>Kontaktam nav norādīta e-pasta adrese!</p>
        }
      }
      @if (client && client.webUsers && client.webUsers.length > 0) {
        <p class="mt-2"><strong>Portāla lietotāji (Bcc)</strong></p>
        <div nz-row>
          @for (webUser of client.webUsers; track webUser.id) {
            <div nz-col nzSpan="12">
              <label nz-checkbox [(ngModel)]="webUser.selected">{{ webUser.login }}</label>
            </div>
          }
        </div>
      }
      <p class="mt-2"><strong>Papildus teksts</strong></p>
      <textarea rows="8" nz-input placeholder="Papildus teksts e-pastā" [(ngModel)]="clientNotificationConfig.additionalMessage"></textarea>
    </div>
  }
  <div *nzModalFooter>
    <button nz-button nzType="default" [disabled]="loading" (click)="cancel()">Atcelt</button>
    <button nz-button nzType="primary" [disabled]="loading || (client && !client.clientEmail) || (!client && contact && !contact.contactEmail)" (click)="sendNotification()">Nosūtīt</button>
  </div>
</nz-spin>
